import { useState } from "react";
// import { pipeline } from "stream"; // Removed - Node.js module not available in browser

const PipelineStageButtons = ({onPipelineChange, selectedPipelineStage, pipelineStageCount}) => {
    const handleStatusClick = (status) => {
        const isEqual = Array.isArray(selectedPipelineStage) && 
                       Array.isArray(status) &&
                       selectedPipelineStage.length === status.length &&
                       selectedPipelineStage.every((val, index) => val === status[index]);
                       
        const newPipelineStage = isEqual ? null : status;
        onPipelineChange(newPipelineStage);
    }
    return(
    <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-2 w-full md:w-auto">
        <h6 className="text-[#94A3B8] text-xs md:text-base whitespace-nowrap flex-shrink-0">
          Pipeline:
        </h6>
        {/* Horizontal scroll container for mobile */}
        <div className="overflow-x-auto md:overflow-visible -mx-3 px-3 md:mx-0 md:px-0">
            <div className="flex gap-2 md:gap-1 min-w-max">
                <button 
                onClick={() => handleStatusClick([0])}
                type="button"
                tabIndex={0}
                >
                    <span className="text-gray-600 bg-gray-100 border-gray-100 inline-flex items-center justify-center min-w-[44px] h-11 md:h-[34px] px-3 md:px-4 rounded-full border font-medium text-sm">
                    {pipelineStageCount.find(item => item.pipeline_stage === 0)?.count || ""}
                    </span>
                </button>
                <button 
                onClick={() => handleStatusClick([1])}
                type="button"
                tabIndex={0}
                >
                    <span className="text-[#1E293B] bg-[#FEFAD8] border-[#FEFAD8] inline-flex items-center justify-center min-w-[44px] h-11 md:h-[34px] px-3 md:px-4 rounded-full border font-medium text-sm">
                    {pipelineStageCount.find(item => item.pipeline_stage === 1)?.count || ""}
                    </span>
                </button>
                <button 
                onClick={() => handleStatusClick([2])}
                type="button"
                tabIndex={0}
                >
                <span className="text-[#262BC6] bg-[#BEC2FF] border-[#BEC2FF] inline-flex items-center justify-center min-w-[44px] h-11 md:h-[34px] px-3 md:px-4 rounded-full border font-medium text-sm">
                    {pipelineStageCount.find(item => item.pipeline_stage === 2)?.count || ""}
                </span>
                </button>
                <button 
                onClick={() => handleStatusClick([3])}
                type="button"
                tabIndex={0}
                >
                <span className="text-[#00658E] bg-[#E3F3FF] border-[#E3F3FF] inline-flex items-center justify-center min-w-[44px] h-11 md:h-[34px] px-3 md:px-4 rounded-full border font-medium text-sm">
                    {pipelineStageCount.find(item => item.pipeline_stage === 3)?.count || ""}
                </span>
                </button>
                <button
                onClick={() => handleStatusClick([4,5])}
                type="button"
                tabIndex={0}
                >
                <span className="text-[#116D26] bg-[#E7FFD6] border-[#E7FFD6] inline-flex items-center justify-center min-w-[44px] h-11 md:h-[34px] px-3 md:px-4 rounded-full border font-medium text-sm">
                    {(pipelineStageCount.find(item => item.pipeline_stage === 4)?.count || 0) +
                    (pipelineStageCount.find(item => item.pipeline_stage === 5)?.count || 0)} 
                </span>
                </button>
                <button 
                onClick={() => handleStatusClick([6])}
                type="button"
                tabIndex={0}
                className="mx-1"
                >
                <span className="border-[#E3F3FF] bg-red-100 text-red-500 w-[46px] h-[34px] pt-2 px-4 pb-2 gap-2 rounded-full border">
                    {pipelineStageCount.find(item => item.pipeline_stage === 6)?.count || 0}
                </span>
                </button>
            </div>
        </div>
    </div>
    )
}
export default PipelineStageButtons;